module.exports = __webpack_public_path__ + "img/down-arrow.17a1d687.svg";